import { useSuspenseQuery } from '@tanstack/react-query';
import { type UserData } from '../../../../types/isomorphic';
import useApi from '../useApi';
import { USER_QUERY_KEYS } from './keys';

const useUserQuery = () => {
  const { userService } = useApi();

  const fetchUser = async (): Promise<UserData> => {
    const result = await userService.getUserData();
    return result;
  };

  const query = useSuspenseQuery<UserData>({
    queryKey: USER_QUERY_KEYS.user(),
    queryFn: fetchUser,
  });
  return { ...query, response: query.data };
};

export default useUserQuery;
